var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.allowed && _vm.customerId)?_c('v-btn',{attrs:{"small":"","outlined":"","color":"primary","loading":_vm.impersonating},on:{"click":_vm.open}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v("mdi-account-eye-outline")]),_vm._v(_vm._s(_vm.$t('customer.client-space-impersonate'))+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }